import { useEffect, useState } from "react";
import usePersonStore from "../../../store/personStore";
import useLoyaltyStore from "../../../store/loyaltyStore";
import { CheckCircleIcon } from "../../../icons";
import { AlertBanner } from "../../../components/ui/AlertBanner";

export const ServiceOptions = ({ state, dispatch }) => {
  // Step One: Here the user chooses the types of services
  // he/she wants to book an appointment for.

  // LOCAL STATE:
  const [pickupDisabled, setPickupDisabled] = useState(false)
  const [firstAvailableDisabled, setFirstAvailableDisabled] = useState(false)
  const { isLoyaltyEligible, loyaltyInfo } = usePersonStore.getState();
  const { loyaltyProducts } = useLoyaltyStore.getState();

  const productAwardPoints = loyaltyProducts?.filter((product) => product?.name === "Pick Up Booking")?.[0]?.accrualPoints

  // FETCH DATA:

  // LOCAL VARIABLES:

  const isLoyaltyHidden = isLoyaltyEligible && state?.pickupCost > 0 && state?.loyaltyCost <= loyaltyInfo?.awardPoints

  const pickupLabel = state?.pickupCost === 0 ? 'Δωρεάν' : `${state?.pickupCost}€`
  const pickupBadgeColor = state?.pickupCost > 0 ? 'bg-[#D4002A]' : 'bg-mildgrey'
  const pickupTextColor = state?.pickupCost === 0 ? 'text-black' : 'text-white'
  
  // USE EFFECTS:
  useEffect(()=>{
    const options = [...state?.stepThreeOptions?.CRMOptions, ...state?.stepThreeOptions?.pickupOptions, ...state?.stepThreeOptions?.availabilityOptions]

    if(!options?.includes("PickupCRMForm") && state?.stepTwoAvailableAppointments?.pickup === null){
      setPickupDisabled(true)
    }
    if(!options?.includes("CRMForm") && state?.stepTwoAvailableAppointments?.firstAvailable === null ){
      setFirstAvailableDisabled(true)
    }
  },[state?.stepTwoAvailableAppointments])

  useEffect(() => {
    const options = [...state?.stepThreeOptions?.CRMOptions, ...state?.stepThreeOptions?.pickupOptions, ...state?.stepThreeOptions?.availabilityOptions]
    const hasBoth = ["CRMForm", "PickupCRMForm"].every(opt => options.includes(opt));

    if(hasBoth){
      dispatch({type: "SET_LOCK_STEPPER_NEXT", lockStepperNext:true})
    } else if(!state?.stepTwoAvailableAppointments?.firstAvailable && !state?.stepTwoAvailableAppointments?.pickup) {
      dispatch({type: "SET_LOCK_STEPPER_NEXT", lockStepperNext:false})
    } 
  },[dispatch, state?.stepThreeOptions?.CRMOptions, state?.stepThreeOptions?.availabilityOptions, state?.stepThreeOptions?.pickupOptions, state?.stepTwoAvailableAppointments])

  // HANDLERS & FUNCTIONS:

  return (
    <div className = 'flex flex-col gap-10'>
      <div className='grid grid-cols-2 gap-3 max-lg:grid-cols-1'>
        <div className={`bg-white flex flex-col ${[...state?.stepThreeOptions?.CRMOptions, ...state?.stepThreeOptions?.pickupOptions, ...state?.stepThreeOptions?.availabilityOptions].includes("PickupAvis") && "justify-between"} gap-2 w-full p-6 border ${!pickupDisabled && 'cursor-pointer'} ${state?.selectedPickup ? "outline outline-1 outline-[#070707] border-[#070707]" : "border-fadedgrey"} rounded-xl`}
          onClick={()=> {
            if(!pickupDisabled){
              dispatch({type: "SET_SELECTED_PICKUP", selectedPickup:true})
              dispatch({ type: "SET_SELECTED_PAYMENT", selectedPayment: 'cash' });
            }
          }
        }>
          <div className='flex flex-row justify-between items-start gap-4'>
            <p className={`text-lg font-bold ${pickupDisabled && 'text-fadedgrey'}`}>Pick-Up & Delivery</p>
            {!isLoyaltyHidden && (<div className={`flex justify-center items-center w-[73px] h-[26px] ${state?.pickupCost === 0 ? "font-semibold" : "font-medium"} ${pickupBadgeColor} ${pickupTextColor}  text-sm px-2 py-1 rounded-[4px]`}>
              {pickupLabel}
            </div>)}
          </div>
          <p className={`text-sm ${pickupDisabled && 'text-fadedgrey'}`}>Παραλαμβάνουμε το αυτοκίνητο από το σημείο που σε εξυπηρετεί, σου παραδίδουμε αυτοκίνητο αντικατάστασης και επιστρέφουμε το αυτοκίνητο στον χώρο σου αφού ολοκληρωθούν οι εργασίες.</p>
          {[...state?.stepThreeOptions?.CRMOptions, ...state?.stepThreeOptions?.pickupOptions, ...state?.stepThreeOptions?.availabilityOptions].includes("PickupAvis") &&  <p className={`text-sm font-bold ${!state?.stepTwoAvailableAppointments?.pickup && "text-primary"}`}>
            {state?.stepTwoAvailableAppointments?.pickup ? `Διαθέσιμο από ${state?.stepTwoAvailableAppointments?.pickup}` : "Δεν υπάρχουν διαθέσιμα ραντεβού"}
          </p>}
          {isLoyaltyHidden && <p className='mt-2 px-2 py-1 rounded-md bg-primary max-w-[255px] text-white text-sm'>Δωρεάν με χιλιόμετρα Avis More ✨</p>}
        </div>
        <div className={`bg-white flex flex-col gap-2 justify-between w-full p-6 border ${!firstAvailableDisabled && 'cursor-pointer'} ${state?.selectedPickup ? "border-fadedgrey" : "outline outline-1 outline-[#070707] border-[#070707]" } rounded-xl`}
          onClick={()=> {
            if(!firstAvailableDisabled) {
              dispatch({type: "SET_SELECTED_PICKUP", selectedPickup:false})
              dispatch({ type: "SET_SELECTED_PAYMENT", selectedPayment: null });
            }
          }}>
          <div>
            <p className={`text-lg font-bold pb-2 ${firstAvailableDisabled && 'text-fadedgrey'}`}>Ραντεβού σε συνεργείο</p>
            <p className={`text-sm ${firstAvailableDisabled && 'text-fadedgrey'}`}>Προγραμμάτισε το ραντεβού σου, επιλέγοντας το συνεργείο, την ημέρα και την ώρα που σε εξυπηρετούν.</p>
          </div>
          {([...state?.stepThreeOptions?.CRMOptions, ...state?.stepThreeOptions?.pickupOptions, ...state?.stepThreeOptions?.availabilityOptions].includes("FirstAvailableAvis") 
          || [...state?.stepThreeOptions?.CRMOptions, ...state?.stepThreeOptions?.pickupOptions, ...state?.stepThreeOptions?.availabilityOptions].includes("NearestAvis")) && 
          <p className={`text-sm font-bold ${!state?.stepTwoAvailableAppointments?.firstAvailable && "text-primary"}`}>
            {state?.stepTwoAvailableAppointments?.firstAvailable ? `Διαθέσιμο από ${state?.stepTwoAvailableAppointments?.firstAvailable}` : "Δεν υπάρχουν διαθέσιμα ραντεβού"}
          </p>}
        </div>
      </div>
      {/* {state?.pickupCost > 0 && isLoyaltyEligible && !!productAwardPoints && productAwardPoints > 0 && <AlertBanner severity="info" className='pb-1'> */}
      {state?.pickupCost > 0 && isLoyaltyEligible && <AlertBanner severity="info" className='pb-1'>
            <div className='flex flex-row gap-[14px] justify-start align-top p-3'>
                <CheckCircleIcon width='20' height='20' className={'stroke-[#2E9BFF] shrink-0'} />
                <p className='text-sm font-semibold'>Κέρδισε ακόμα περισσότερα χιλιόμετρα επιλέγοντας Pick-Up & Delivery!</p>
            </div>
        </AlertBanner>
        }
    </div>
  );
};